<template>
	<div v-if="isReply" style="padding-left: 10px;padding-right: 10px;padding-top: 10px;">
		<van-list :finished="true">
			<div style="border-radius: 12px;background-color: #FFF;padding-bottom: 10px;">
				<div v-for="customer in customerList">
					<div style="padding: 10px;">
						<Row class="code-row-bg">
							<Image :src="customer.avatar" width="40px" height="40px">
								<template #error>
									<Icon type="ios-image-outline" size="24" color="#ccc" />
								</template>
							</Image>
							<div style="text-align: left;height: 54px;margin-left: 12px;">
								<p style="text-indent: 0em; font-size: 14px;color: #343A4A;">{{ (customer.rep === 0 ?
                                    customer.nickName :
                                    $t('msg.serviceReply')) }}</p>
								<p style="color: #9095A6;font-size: 12px;text-indent: 0em;">
									{{ formatDate(new Date(customer.createTime / 1), 'yyyy-MM-dd hh:mm: ss') }}
								</p>
							</div>
						</Row>
						<div style="background-color: #F5F5F5;border-radius: 8px;padding: 10px;">
							<p
								style="text-indent: 0em;font-size: 14;color: #4E5055;word-wrap: break-word; word-break: break-all;">
								{{ customer.repair }}
							</p>
							<div v-if="customer.imgUrl != '' && customer.imgUrl != null"
								@click="handleShowPreview(customer.imgUrl)" style="text-align: left;">
								<Image :src="customer.imgUrl" width="125px" height="125px">
									<template #error>
										<Icon type="ios-image-outline" size="24" color="#ccc" />
									</template>
								</Image>
							</div>
						</div>
					</div>
				</div>
				<div v-if="status != '2'" style="margin: 16px;">
					<van-button round block type="default" @click="createReplyFlag = true"
						style="background-color: #FFFFFF;">
						<span style="font-size: 14;color: #4E5055;">{{ $t('msg.reply') }}</span>
					</van-button>
				</div>
			</div>
		</van-list>
		<div v-if="status != '2'" style="text-align: center;">
			<div style="margin: 16px; margin-bottom: 0px;">
				<van-button round block style="background-color:#E18738" @click="isClose = true">{{
                    $t('msg.shutQuestions') }}</van-button>
				<Modal v-model="isClose" :title="$t('msg.shutQuestions')" @on-ok="close()">
					<p>{{ $t('msg.isShutQuestions') }}</p>
				</Modal>
			</div>

		</div>
	</div>
	<div v-if="!isReply" style="padding-top: 20px;">
		<van-form label-width="65px" @submit="submit(0)">
			<van-cell-group inset>
				<van-field v-model="newForm.phone" type="tel" name="phone" :label="$t('msg.phone')"
					:placeholder="$t('msg.phonePlaceholder')"
					:rules="[{ required: true, message: $t('msg.phoneMessage') }]" />
				<van-field v-model="newForm.repair" type="textarea" show-word-limit maxlength="300" name="content"
					:label="$t('msg.content')" :placeholder="$t('msg.contentPlaceholder')"
					:rules="[{ required: true, message: $t('msg.contentMessage') }]" />
				<van-field name="uploader" :label="$t('msg.imgUploader')">
					<template #input>
						<!-- <van-uploader :reupload="true" :after-read="afterRead" :before-delete="beforeDelete"
                                    accept='image/*' v-model="imgUrl" :max-count="1" /> -->
						<div @click="uploadImg">
							<div style="background-color: #EFF1F3;">
								<Image :src="newForm.imgUrl" width="95px" height="95px">
									<template #error>
										<Icon type="ios-image-outline" size="60" color="#ccc" />
									</template>
								</Image>
							</div>
							<div style="width: 95px;text-align: center;">
								<span style="color: #9095A6; font-size: 12px;">{{ newForm.imgUrl != null &&
						            newForm.imgUrl != '' ?
						            $t('msg.clickSwitchImg') : $t('msg.clickUploadImg') }}</span>
							</div>
						</div>
					</template>
				</van-field>
			</van-cell-group>
			<div style="margin: 16px;">
				<van-button round block style="background-color: #E18738;" native-type="submit">
					{{ $t("msg.submit") }}
				</van-button>
			</div>
		</van-form>
	</div>

	<Modal v-model="createReplyFlag" :title="$t('msg.userCustomer')" footer-hide>
		<div>
			<van-form label-width="65px">
				<van-cell-group inset>
					<van-field v-model="newForm.repair" type="textarea" show-word-limit maxlength="300" name="content"
						:label="$t('msg.content')" :placeholder="$t('msg.contentPlaceholder')"
						:rules="[{ required: true, message: $t('msg.contentMessage') }]" />
					<van-field name="uploader" :label="$t('msg.imgUploader')">
						<template #input>
							<!-- <van-uploader :reupload="true" :after-read="afterRead" :before-delete="beforeDelete"
                                        accept='image/*' v-model="imgUrl" :max-count="1" /> -->
							<div @click="uploadImg">
								<div style="background-color: #EFF1F3;">
									<Image :src="newForm.imgUrl" width="95px" height="95px">
										<template #error>
											<Icon type="ios-image-outline" size="60" color="#ccc" />
										</template>
									</Image>
								</div>
								<div style="width: 95px;text-align: center;">
									<span style="color: #9095A6; font-size: 12px;">{{ newForm.imgUrl != null &&
							            newForm.imgUrl != '' ?
							            $t('msg.clickSwitchImg') : $t('msg.clickUploadImg') }}</span>
								</div>
							</div>
						</template>

					</van-field>
				</van-cell-group>
			</van-form>
		</div>
		<div style="display: flex; justify-content: flex-end">
			<Button style="margin-right: 15px" type="default" @click="createReplyFlag = false">{{ $t('msg.cancel')
            }}</Button>
			<Button type="primary" @click="submit(1)">{{ $t('msg.determine') }}</Button>
		</div>
	</Modal>

	<ImagePreview v-model="preview" :preview-list="urlList" />
</template>

<script>
	import {
		useI18n
	} from "vue-i18n";
	import {
		useStore
	} from "vuex";
	import http from '../utils/request.js'
	import {
		uploadFile
	} from '../utils/upload.js'
	import api from '../api/index.js'
	export default {
		components: {},
		data() {
			return {
				active: 0,
				isReply: true,
				isClose: false,
				createReplyFlag: false,
				newForm: {
					id: '',
					repair: '',
					phone: '',
					motoId: '',
					deptId: '',
					pid: '0',
					imgUrl: ''
				},
				imgUrl: [],
				urlList: [],
				customerList: [],
				closeFrom: {
					id: ''
				},
				preview: false,
				status: 0
			}
		},
		methods: {
			// submit(type) {
			// 	var data = this;
			// 	if (type === 0) {
			// 		// 调用提交预约申请
			// 		window.flutter_inappwebview.callHandler('httpPost', {
			// 				'path': '/system/service/createWorkOrder',
			// 				'data': this.newForm
			// 			})
			// 			.then((result) => {
			// 				// 弹出成功提示
			// 				data.$Message.success(this.$t('msg.submitSuccess'))
			// 				data.getCustomerList()
			// 				data.newForm = {
			// 					id: data.newForm.id,
			// 					repair: '',
			// 					phone: '',
			// 					motoId: data.newForm.motoId,
			// 					deptId: data.newForm.deptId,
			// 					pid: '0',
			// 					imgUrl: ''
			// 				};
			// 				data.imgUrl = [];
			// 			});
			// 	} else {
			// 		// 回复
			// 		data.newForm.phone = '';
			// 		// 获取pid值
			// 		if (true) {
			// 			data.newForm.pid = this.customerList[this.customerList.length - 1].repairId;
			// 		}
			// 		window.flutter_inappwebview.callHandler('httpPost', {
			// 				'path': '/system/service/createWorkOrder',
			// 				'data': this.newForm
			// 			})
			// 			.then((result) => {
			// 				data.$Message.success(this.$t('msg.submitSuccess'))
			// 				data.createReplyFlag = false;
			// 				data.getCustomerList()
			// 				data.newForm = {
			// 					id: data.newForm.id,
			// 					repair: '',
			// 					phone: '',
			// 					pid: '0',
			// 					motoId: data.newForm.motoId,
			// 					deptId: data.newForm.deptId,
			// 					imgUrl: ''
			// 				};
			// 				data.imgUrl = [];
			// 			});
			// 	}
			// },
			submit(type) {
				if (type === 0) {
					// 提交预约申请
					api.systemServiceApi.createWorkOrder(this.newForm)
						.then((result) => {
							this.$Message.success(this.$t('msg.submitSuccess'));
							this.getCustomerList();
							this.resetForm();
						});
				} else {
					// 回复
					this.newForm.phone = '';
					this.newForm.pid = this.customerList[this.customerList.length - 1].repairId;

					api.systemServiceApi.createWorkOrder(this.newForm)
						.then((result) => {
							this.$Message.success(this.$t('msg.submitSuccess'));
							this.createReplyFlag = false;
							this.getCustomerList();
							this.resetForm();
						});
				}
			},
			// close() {
			// 	var data = this;
			// 	this.closeFrom.id = this.customerList[0].repairId;
			// 	window.flutter_inappwebview.callHandler('httpPost', {
			// 			'path': '/system/service/completeTimeWorkOrder',
			// 			'data': this.closeFrom
			// 		})
			// 		.then((result) => {
			// 			this.$Message.success(this.$t('msg.shutSuccess'))
			// 			data.customerList = [];
			// 			data.isReply = false;
			// 			data.newForm = {
			// 				id: data.newForm.id,
			// 				repair: '',
			// 				phone: '',
			// 				pid: '0',
			// 				motoId: data.newForm.motoId,
			// 				deptId: data.newForm.deptId,
			// 				imgUrl: ''
			// 			};
			// 			data.imgUrl = [];
			// 		});
			// },
			close() {
				this.closeFrom.id = this.customerList[0].repairId;
				api.systemServiceApi.completeTimeWorkOrder(this.closeFrom)
					.then((result) => {
						this.$Message.success(this.$t('msg.shutSuccess'));
						this.customerList = [];
						this.isReply = false;
						this.resetForm();
					});
			},
			handleShowPreview(imgUrl) {
				this.preview = true;
				this.urlList = [imgUrl];
			},
			uploadImg() {
				// 1. 创建 input 元素
				const input = document.createElement('input');
				input.type = 'file';
				input.accept = 'image/*';

				// 使用 Promise 包装文件选择
				input.onchange = (e) => new Promise(async (resolve, reject) => {
					const file = e.target.files[0];
					if (!file) return reject('未选择文件');

					try {
						// 2. 获取上传 URL
						const res = await api.systemServiceApi.getUploadUrl({
							fileSuffix: file.name.split('.').pop(),
							fileType: 0
						});

						if (res.code !== 200) throw new Error('获取上传链接失败');

						// 3. 上传文件
						await uploadFile(res.data.url, file);

						// 4. 上传成功后再设置URL
						this.newForm.imgUrl = res.data.url.split('?')[0];
						console.log('上传完成后的URL:', this.newForm.imgUrl);
						resolve();
					} catch (error) {
						console.error('上传失败:', error);
						this.$Message.error('上传失败，请重试');
						reject(error);
					}
				});

				input.click();
			},
			// getCustomerList() {
			// 	var data = this;
			// 	if (this.newForm.id != null && this.newForm.id != '') {
			// 		window.flutter_inappwebview.callHandler('httpPost', {
			// 				'path': '/system/service/getCustomerInfos',
			// 				'data': this.newForm
			// 			})
			// 			.then((result) => {
			// 				data.customerList = result;
			// 				data.isReply = data.customerList.length > 0;
			// 			});
			// 	} else {
			// 		window.flutter_inappwebview.callHandler('httpPost', {
			// 				'path': '/system/service/getCurrentCustomer',
			// 				'data': {}
			// 			})
			// 			.then((result) => {
			// 				data.customerList = result;
			// 				data.isReply = data.customerList.length > 0;
			// 			});
			// 	}

			// },
			getCustomerList() {
				if (this.newForm.id != null && this.newForm.id != '') {
					api.systemServiceApi.getCustomerInfos(this.newForm)
						.then((result) => {
							this.customerList = result;
							this.isReply = this.customerList.length > 0;
						});
				} else {
					api.systemServiceApi.getCurrentCustomer()
						.then((result) => {
							this.customerList = result;
							this.isReply = this.customerList.length > 0;
						});
				}
			},
			//重置表单
			resetForm() {
				this.newForm = {
					id: this.newForm.id,
					repair: '',
					phone: '',
					motoId: this.newForm.motoId,
					deptId: this.newForm.deptId,
					pid: '0',
					imgUrl: ''
				};
				this.imgUrl = [];
			},
			formatDate(date, format) {
				let time = {
					'M+': date.getMonth() + 1,
					'd+': date.getDate(),
					'h+': date.getHours(),
					'm+': date.getMinutes(),
					's+': date.getSeconds(),
					'q+': Math.floor((date.getMonth() + 3) / 3),
					'S+': date.getMilliseconds()
				}
				if (/(y+)/i.test(format)) {
					format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
				}
				for (let k in time) {
					if (new RegExp('(' + k + ')').test(format)) {
						format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? time[k] : ('00' + time[k]).substr(('' +
							time[k]).length));
					}
				}
				return format;
			},
			afterRead(file) {
				if (file.content.startsWith("data:image/")) {
					this.uploadImg(file)
				} else {
					this.$Message.error(this.$t('msg.imgUploaderMessage'));
					this.imgUrl = []
					this.newForm.imgUrl = '';
				}

			},
			beforeDelete(file, detail) {
				this.imgUrl = []
				this.newForm.imgUrl = '';
			},

		},
		mounted() {
			this.newForm.motoId = this.$route.query.motoId;
			this.newForm.deptId = this.$route.query.deptId;
			this.newForm.id = this.$route.query.id;
			this.status = this.$route.query.status;
			this.getCustomerList();

			// var lang = this.$route.query.lang;
			// if(lang != null){
			//     const store = useStore();
			//     const i18n = useI18n();
			//     i18n.locale.value = lang;
			//     store.commit("setLanguage", lang);
			// }

			document.querySelector('body').setAttribute('style', 'background-color:#eff2f5');
			document.title = this.$t('msg.userCustomer')
		}
	}
</script>